import(/* webpackMode: "eager" */ "/app/apps/ensadmin/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppSidebar"] */ "/app/apps/ensadmin/src/components/app-sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ENSNodeProvider"] */ "/app/apps/ensadmin/src/components/providers/ensnode-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryClientProvider"] */ "/app/apps/ensadmin/src/components/query-client/components.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RequireActiveENSNodeConnection"] */ "/app/apps/ensadmin/src/components/require-active-ensnode-connection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header","HeaderNav","HeaderBreadcrumbs","HeaderActions"] */ "/app/apps/ensadmin/src/components/ui/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarProvider","SidebarInset"] */ "/app/apps/ensadmin/src/components/ui/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/apps/ensadmin/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ENSNodeConnectionsProvider"] */ "/app/apps/ensadmin/src/hooks/ensnode-connections.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.4.7_@opentelemetry+api@1.9.0_patch_hash=4b2adeefaf7c22f9987d0a125d69cab900719be_b35e4f981d79543c356a6d07874c5956/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"variable\":\"--font-inter\",\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
